/**
 * Translation helpers for dynamic DB content (categories, shops, products, news, etc.).
 * Convention: DB has base Arabic field (e.g. `name_ar` or `name`) plus optional
 * `name_ku` and `name_en` translations. Frontend uses `tField(item, "name", lang)` which:
 *   1. tries `name_${lang}` (e.g. `name_en`)
 *   2. falls back to `name_ar` if not empty (for categories)
 *   3. falls back to the base `name` field (for shops/products/news)
 *   4. finally returns empty string
 */
export function tField(item, base, lang) {
  if (!item) return "";
  const isDefault = !lang || lang === "ar";
  if (isDefault) {
    // Prefer name_ar, else name
    return item[`${base}_ar`] || item[base] || "";
  }
  // Non-Arabic: try localized, else fallback chain
  const localized = item[`${base}_${lang}`];
  if (localized) return localized;
  return item[`${base}_ar`] || item[base] || "";
}

/**
 * Convenience: return category's localized name.
 * Categories store the Arabic name in `name_ar`.
 */
export function catName(cat, lang) {
  return tField(cat, "name", lang);
}

/**
 * Convenience: return shop's localized name / description.
 * Shops store the Arabic name in `name` (legacy).
 */
export function shopName(shop, lang) {
  if (!shop) return "";
  if (!lang || lang === "ar") return shop.name || "";
  return shop[`name_${lang}`] || shop.name || "";
}

export function shopDescription(shop, lang) {
  if (!shop) return "";
  if (!lang || lang === "ar") return shop.description || "";
  return shop[`description_${lang}`] || shop.description || "";
}
